export default "/images/vendor/flag-icon-css/flags/4x3/li.svg?637cad1d9f490bd27b72b2d6894b99ab";